import {
  ADD_FRIEND,
  ADD_FRIEND_ERROR,
  GET_FRIENDS,
  GET_FRIENDS_ERROR,
  REMOVE_FRIEND,
  REMOVE_FRIEND_ERROR,
  GET_FOLLOWERS,
  GET_FEED_REVIEWS,
  GET_FEED_TRIPS,
} from "../types";

const FriendReducer = (state, action) => {
  switch (action.type) {
    case GET_FRIENDS:
      return {
        ...state,
        friends: (action.payload || []).map((f) => ({ ...f, changed: false })),
        loading: false,
      };
    case ADD_FRIEND:
      // Mark added users as changed in the followers list (for "Follow back" toggle)
      const addedIds = (action.payload || []).map((f) => f.user_id);
      return {
        ...state,
        followers: state.followers.map((f) =>
          addedIds.includes(f.user_id) ? { ...f, changed: true } : f
        ),
        loading: false,
      };
    case REMOVE_FRIEND:
      const removedIds = (action.payload || []).map((f) => f.user_id);
      return {
        ...state,
        friends: state.friends.map((f) =>
          removedIds.includes(f.user_id) ? { ...f, changed: true } : f
        ),
        loading: false,
      };
    case GET_FOLLOWERS:
      return {
        ...state,
        followers: (action.payload.items || []).map((f) => ({ ...f, changed: false })),
        followersPage: action.payload.page,
        followersTotal: action.payload.total,
        followersHasMore: action.payload.has_more,
        loading: false,
      };
    case GET_FEED_REVIEWS:
      return {
        ...state,
        feedReviews: action.payload.items || [],
        feedReviewsPage: action.payload.page,
        feedReviewsTotal: action.payload.total,
        feedReviewsHasMore: action.payload.has_more,
        loading: false,
      };
    case GET_FEED_TRIPS:
      return {
        ...state,
        feedTrips: action.payload.items || [],
        feedTripsPage: action.payload.page,
        feedTripsTotal: action.payload.total,
        feedTripsHasMore: action.payload.has_more,
        loading: false,
      };
    case GET_FRIENDS_ERROR:
    case ADD_FRIEND_ERROR:
    case REMOVE_FRIEND_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default FriendReducer;
